var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-block-list-rte",attrs:{"id":("block-" + (_vm.$vnode.key))}},[(_vm.title)?_c('LongReadTarget',{staticClass:"relative mb-2xs/v",attrs:{"container-id":("block-" + (_vm.$vnode.key)),"link-to-toc":{
			name: ("Spring til \"" + _vm.title + "\" i indholdsfortegnelsen"),
			attrs: {
				'data-focus-ignore': true,
			},
		},"title":_vm.title,"disabled":!_vm.showTitleInToc}},[_c('BaseH2',{domProps:{"textContent":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"s-rich-text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }